import { useQuery } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { DealQuestionAnswer, Guid } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDealQuestionAnswersQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(QueryKeys.Questions.Answers(guid), ({ queryKey }) => {
		const [_, dealGuid] = queryKey;

		return AxiosUtils.getResponseData<DealQuestionAnswer[]>(
			api.get(CerebroApiEndpoints.Questions.Answers(dealGuid))
		);
	});
}
